import React from 'react';
import { Typography } from '@hpstellar/core';
import { connect } from 'react-redux';
import { fetchHeaderFooterComponent } from '../header-footer/header-footer-actions';
import { Helpers } from '../../../core/src/helpers';
import RichContent from '../../../utility/components/rich-content';

import './disclaimer-list.less';

const DEFAULT_DISCLAIMER = [];
const EMPTY_OBJ = {};

class DisclaimerList extends React.PureComponent {
    componentDidMount() {
        const { fetchDisclaimer, sections, customHtml, disclaimerHtml } = this.props;

        // TODO: need a better flag for if the data needs to be fetched
        if (!customHtml && !disclaimerHtml && (!sections || sections.length === 0)) {
            fetchDisclaimer();
        }
    }

    render() {
        const {
            sections = DEFAULT_DISCLAIMER,
            featuresDisclaimers,
            techSpecDisclamers,
            customHtml,
            disclaimerHtml,
            useRichContent,
        } = this.props;
        const headerStyle = { marginBottom: '1rem' };

        const htmlContent = customHtml || disclaimerHtml;
        if (htmlContent) {
            return (
                <div
                    className="disclaimer-content custom-content"
                    {...(!useRichContent && { dangerouslySetInnerHTML: Helpers.createMarkup(htmlContent) })}
                >
                    {useRichContent && <RichContent raw={htmlContent} design="v2" />}
                </div>
            );
        }

        return (
            <div className={'disclaimer-content'}>
                {sections.map((el, idx) => (
                    <Typography variant="bodyS" key={idx}>
                        {el}
                    </Typography>
                ))}
                {featuresDisclaimers && featuresDisclaimers.length > 0 ? (
                    <>
                        <Typography isCaps tag="h4" variant="boldS" style={headerStyle}>
                            Features
                        </Typography>
                        {featuresDisclaimers.map((el, idx) =>
                            el ? (
                                <Typography variant="bodyS" key={idx}>
                                    {el}
                                </Typography>
                            ) : null
                        )}
                    </>
                ) : null}
                {techSpecDisclamers && techSpecDisclamers.length > 0 ? (
                    <>
                        <Typography isCaps tag="h4" variant="boldS" style={headerStyle}>
                            Technical Details
                        </Typography>
                        {techSpecDisclamers.map((el, idx) =>
                            el ? (
                                <Typography variant="bodyS" key={idx}>
                                    {el}
                                </Typography>
                            ) : null
                        )}
                    </>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const { disclaimer } = state.headerFooter || EMPTY_OBJ;
    const { components = EMPTY_OBJ } = state.slugInfo || EMPTY_OBJ;
    const { pdpFeatures = EMPTY_OBJ, product = EMPTY_OBJ } = components;
    const { disclaimers: featuresDisclaimers } = pdpFeatures || {};
    const { disclaimers: techSpecDisclamers } = product || {};

    return {
        sections: disclaimer.sections,
        disclaimerHtml: disclaimer.customHtml,
        featuresDisclaimers,
        techSpecDisclamers,
    };
};

const mapDispatchToProps = dispatch => ({
    fetchDisclaimer: () => dispatch(fetchHeaderFooterComponent(['disclaimer'])),
});

export default connect(mapStateToProps, mapDispatchToProps)(DisclaimerList);
